import u from '@/utils'
import axios from 'axios'

const state = {
  botTemplatesLoading: false,
  botTemplates: [],
  botTemplateHive: {},
  botTemplateHiveData: {},
  bots: {}
}

const mutations = {
  setbotTemplatesLoading(state, isLoading) {
    state.botTemplatesLoading = isLoading
  },
  setBotTemplates(state, botTemplates) {
    state.botTemplates = botTemplates
  },

  setBotTemplateHiveData(state, botTemplateHiveData) {
    state.botTemplateHiveData = botTemplateHiveData
  },

  updateBotTemplate(state, botTemplate) {
    let index = state.botTemplates.findIndex(
      item => item.hexId === botTemplate.hexId
    )
    state.botTemplates.splice(index, 1, botTemplate)
  },

  setBotTemplateHive(state, payload) {
    state.botTemplateHive = {
      ...state.botTemplateHive,
      [payload.botTemplate.hexId]: payload.hive
    }
  },

  setBot(state, payload) {
    state.bots = {
      ...state.bots,
      [payload.botTemplate.hexId]: payload.bots
    }
  }
}

let actions = {
  async fetchBotTemplates({ commit }) {
    commit('setbotTemplatesLoading', true)
    let response = await axios.get('/api/v1/botTemplates')
    let botTemplates = [...response.data._embedded.botTemplates]
    botTemplates = botTemplates.map(botTemplate => u.processResp(botTemplate))
    commit('setBotTemplates', botTemplates)
    commit('setbotTemplatesLoading', false)
    return botTemplates
  },

  async fetchBotTemplateHive({ commit }, botTemplate) {
    let response = await axios.get(
      `/api/v1/botTemplates/${botTemplate.hexId}/hive`
    )
    let hive = u.processResp(response.data)
    commit('setBotTemplateHive', { botTemplate, hive })
    return hive
  },

  async fetchBotTemplateHiveData({ commit }, botTemplate) {
    commit('setBotTemplateHiveData', {})
    let response = await axios.get(
      `/api/v1/botTemplates/${botTemplate.hexId}/hive-bot-data`
    )
    let hiveBotData = u.processResp(response.data)
    commit('setBotTemplateHiveData', hiveBotData)
    return hiveBotData
  },

  async fetchBot({ commit }, botTemplate) {
    let response = await axios.get(
      `/api/v1/botTemplates/${botTemplate.hexId}/bots`
    )
    let bots = [...response.data._embedded.bots]
    bots = bots.map(bot => u.processResp(bot))
    commit('setBot', { botTemplate, bots })
    return bots
  },

  async createBotTemplate(context, botTemplate) {
    let response = await axios.post(`/api/v1/botTemplates/`, botTemplate)
    return response.data
  },

  async saveBotTemplate(context, registerBotTemplate) {
    let formData = Object.keys(registerBotTemplate).reduce((formData, key) => {
      if (registerBotTemplate[key] instanceof Array) {
        registerBotTemplate[key].forEach(
          element => element !== null && formData.append(key, element)
        )
      } else {
        registerBotTemplate[key] !== null &&
          formData.append(key, registerBotTemplate[key])
      }
      return formData
    }, new FormData())
    let response = await axios.post('/api/v1/botTemplates/register', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  },

  async updateBotTemplateBinaries(context, { body, hexId }) {
    let formData = Object.keys(body).reduce((formData, key) => {
      if (body[key] instanceof Array) {
        body[key].forEach(
          element => element !== null && formData.append(key, element)
        )
      } else {
        body[key] !== null && formData.append(key, body[key])
      }
      return formData
    }, new FormData())

    let response = await axios.patch(
      `/api/v1/botTemplates/${hexId}/binaries`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response.data
  },

  async updateBotTemplate({ commit }, { body, hexId }) {
    let response = await axios.patch(`/api/v1/botTemplates/${hexId}`, body)
    response.data = u.processResp(response.data)
    commit('updateBotTemplate', response.data)
    return response.data
  },

  async setHiveToBotTemplate(context, payload) {
    let data = `/api/v1/hives/${payload.hiveId}`
    let response = await axios.put(
      `/api/v1/botTemplates/${payload.botTemplate.hexId}/hive`,
      data,
      {
        headers: {
          'Content-Type': 'text/uri-list'
        }
      }
    )
    return response.data
  },

  async deleteBotTemplate(context, templateHexId) {
    await axios.delete(`/api/v1/botTemplates/${templateHexId}`)
  },

  async incubateBot(context, hexId) {
    let response = await axios.post(`/api/v1/botTemplates/${hexId}/incubate`)
    return response.data
  }
}

export default {
  state,
  actions,
  mutations
}
